export default {
  failed_to_open: 'Kan onboarding voor dit restaurant niet openen. Probeer het opnieuw.',
};
